// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages45_root__q1W2t","title":"AfterImages45_title__1W3DW","images":"AfterImages45_images__P6urg"};